/* eslint-disable require-jsdoc */
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
const Genre = forwardRef((props, ref) => {
  return (
    <div className="hearby-filter-checkboxes" ref={ref}>
    <label className="bluesGenre">
      <input
        type="checkbox"
        onChange={props.onChange}
        className="filterBlues"
        name="Blues"
        checked={props.selected['Blues']}
      />{' '}
      <span>Blues</span>
    </label>
    <label className="ComedyGenre">
      <input
        type="checkbox"
        onChange={props.onChange}
        className="Comedy"
        name="Comedy"
        checked={props.selected['Comedy']}
      />{' '}
      <span>Comedy</span>
    </label>
    <label className="CountryGenre">
      <input
        type="checkbox"
        onChange={props.onChange}
        className="filterCountry"
        name="Country"
        checked={props.selected['Country']}
      />{' '}
      <span>Country</span>
    </label>
    <label className="ElGenre">
      <input
        type="checkbox"
        onChange={props.onChange}
        className="filterEl"
        name="Electronic"
        checked={props.selected['Electronic']}
      />{' '}
      <span>EDM & Electronic</span>
    </label>
    <label className="FolkGenre">
      <input
        type="checkbox"
        onChange={props.onChange}
        className="filterFolk"
        name="Folk"
        checked={props.selected['Folk']}
      />{' '}
      <span>Folk</span>
    </label>
    <label className="IntGenre">
      <input
        type="checkbox"
        onChange={props.onChange}
        className="filterInt"
        name="International"
        checked={props.selected['International']}
      />{' '}
      <span>International</span>
    </label>
    <label className="JazzGenre">
      <input
        type="checkbox"
        onChange={props.onChange}
        className="filterJazz"
        name="Jazz"
        checked={props.selected['Jazz']}
      />{' '}
      <span>Jazz</span>
    </label>
    <label className="PopGenre">
      <input
        type="checkbox"
        onChange={props.onChange}
        className="filterPop"
        name="Pop"
        checked={props.selected['Pop']}
      />{' '}
      <span>Pop</span>
    </label>
    <label className="RapGenre">
      <input
        type="checkbox"
        onChange={props.onChange}
        className="filterRap"
        name="Rap"
        checked={props.selected['Rap']}
      />{' '}
      <span>Rap & Hip-Hop</span>
    </label>
    <label className="RockGenre">
      <input
        type="checkbox"
        onChange={props.onChange}
        className="filterRock"
        name="Rock"
        checked={props.selected['Rock']}
      />{' '}
      <span>Rock</span>
    </label>
  </div>

  );
});
export default Genre;
// Genre.propTypes = {
//   onChange: PropTypes.func,
// };
